import React, { useEffect, useState } from 'react';
import Footer from './Footer';
import Header from './Header';
import Layout from './Layout';

const Terms = () => {
  const [headingStyle, setHeadingStyle] = useState({ fontSize: '32px' });

  useEffect(() => {
    const updateHeadingSize = () => {
      const width = window.innerWidth;
      let fontSize = '32px';
      if (width < 480) fontSize = '20px';
      else if (width < 768) fontSize = '24px';
      else if (width < 1024) fontSize = '28px';
      
      setHeadingStyle({ fontSize });
    };

    updateHeadingSize();
    window.addEventListener('resize', updateHeadingSize);
    
    window.scrollTo(0, 0);
    return () => window.removeEventListener('resize', updateHeadingSize);
  }, []);

  return (
    <>
      <Layout>
        <div style={styles.container}>
          <h1 style={headingStyle}>Terms and Conditions of Use</h1>
          <p style={styles.effectiveDate}>EFFECTIVE SINCE: May 15, 2025</p>
          
          <p>These Terms and Conditions ("Terms") govern your access to and use of the RZTO platform, including all RZTO websites, mobile applications, decentralized telecom infrastructure, Hotspot devices, and digital asset services (collectively, the "Platform"). Please read these Terms carefully before accessing or using the Platform. The Platform is owned and operated by Rizz Network Inc, Virtual Asset Service Provider registered under the laws of Saint Vincent and the Grenadines ("RZTO," "we," "our," or "us").</p>
          
          <p>By accessing the Platform or using any of its services, you agree to these Terms. If you do not agree, you must not use the Platform.</p>

          <section>
            <h2>1. ELIGIBILITY</h2>
            <p>The Platform is available only to users who are at least 18 years of age or the legal age of majority in their jurisdiction. By using the Platform, you represent and warrant that you meet these eligibility requirements and are not subject to sanctions or restrictions under applicable laws.</p>
          </section>

          <section>
            <h2>2. INDEPENDENCE OF ENTITIES</h2>
            <p>RZTO is a separate and independent legal entity incorporated in Saint Vincent and the Grenadines.<strong>The only relationship between RZTO and Rizz Wireless LLC is a limited commercial partnership related exclusively to RZTO's loyalty and rewards program.</strong>  This partnership does not imply any shared ownership, operational control, or legal liability between the two entities.</p>
          </section>

          <section>
            <h2>3. PRIVACY</h2>
            <p>Our Privacy Policy governs the collection, use, and sharing of your personal data. By using the Platform, you agree to the practices outlined in our Privacy Policy, which includes data collected via mobile applications, telecom interactions, staking records, and wallet addresses.</p>
          </section>

          <section>
            <h2>4. PLATFORM SERVICES</h2>
            <p>RZTO offers decentralized mobile services through a blockchain-based infrastructure that includes:</p>
            <ul style={styles.list}>
              <li>Global eSIM connectivity via partner carriers</li>
              <li>Tokenized call-to-earn programs</li>
              <li>Peer-to-peer mobile data trading</li>
              <li>Smart contract staking and reward distribution</li>
              <li>DAO-based protocol governance using $RZTO tokens</li>
              <li>Interoperable DID (Decentralized Identity) for user verification</li>
            <li>Coupon Marketplace: Users can redeem their earned $RZTO tokens for discount coupons and promotional offers from third-party vendors through a dedicated marketplace. All coupons are subject to vendor-specific terms and availability. RZTO acts solely as a facilitator and does not guarantee the value, redemption conditions, or quality of third-party goods and services offered.</li>
             </ul>
            <p>RZTO reserves the right to modify, suspend, or discontinue services at its discretion, with or without prior notice.</p>
          </section>

          <section>
            <h2>5. ACCOUNT REGISTRATION</h2>
            <p>To access certain features, you must create an account, provide accurate and complete information, and keep your account credentials secure. You are solely responsible for activities under your account.</p>
          </section>

          <section>
            <h2>6. INTELLECTUAL PROPERTY</h2>
            <p>All content, software, logos, source code, smart contracts, trademarks, and data visualizations on the Platform are the property of RZTO or its licensors. Unauthorized reproduction or use may result in civil and/or criminal liability.</p>
          </section>

          <section>
            <h2>7. USE RESTRICTIONS</h2>
            <p>You agree not to:</p>
            <ul style={styles.list}>
              <li>Use the Platform for any unlawful purpose or regulatory evasion</li>
              <li>Upload viruses, malware, or any malicious code</li>
              <li>Attempt unauthorized access to systems, smart contracts, or accounts</li>
              <li>Exploit bugs in staking or reward distribution</li>
              <li>Use automation or AI tools to manipulate governance or trading functions</li>
            </ul>
          </section>

          <section>
            <h2>8. TELECOM AND CARRIER COMPLIANCE</h2>
            <p>All use of eSIM and telecom services must comply with local laws and international roaming protocols. You are responsible for:</p>
            <ul style={styles.list}>
              <li>Any applicable carrier fees</li>
              <li>Regulatory telecom registration in your jurisdiction</li>
              <li>Not providing Hotspots in sanctioned and prohibited regions</li>
            </ul>
          </section>

          <section>
            <h2>9. DIGITAL ASSET RISKS</h2>
            <p>You acknowledge and agree that:</p>
            <ul style={styles.list}>
              <li>$RZTO tokens are utility tokens and may have no monetary value</li>
              <li>Rewards are subject to staking participation, protocol rules, and network contributions</li>
              <li>The Platform does not guarantee liquidity, price, or availability of any token</li>
              <li>Custody of private keys is your sole responsibility. Loss of keys means loss of access to assets.</li>
            </ul>
            <p>RZTO disclaims all liability related to third-party exchanges or wallet services.</p>
          </section>

          <section>
            <h2>10. THIRD-PARTY SERVICES</h2>
            <p>The Platform may link to or integrate with telecom carriers, blockchain validators, or external wallets. RZTO is not responsible for third-party actions, service performance, token swaps, or regulatory compliance outside its scope.</p>
          </section>

          <section>
            <h2>11. GOVERNANCE & DAO PARTICIPATION</h2>
            <p>Governance occurs via a decentralized autonomous organization (DAO) where users vote based on staked $RZTO tokens. Governance matters include:</p>
            <ul style={styles.list}>
              <li>Network upgrades</li>
              <li>Protocol parameters</li>
              <li>Community treasury allocations</li>
            </ul>
            <p>Emergency powers may be invoked in case of critical risk to network or user funds. RZTO does not control DAO outcomes but may act as proposer or facilitator.</p>
          </section>

          <section>
            <h2>12. DISCLAIMER OF WARRANTIES</h2>
            <p>The Platform and all services are provided "AS IS" without warranties of any kind. This includes implied warranties of merchantability, fitness for a particular purpose, non-infringement, or uninterrupted service. Token earnings, telecom uptime, or access to governance cannot be guaranteed.</p>
          </section>

          <section>
            <h2>13. LIMITATION OF LIABILITY</h2>
            <p>To the maximum extent permitted by law, RZTO shall not be liable for:</p>
            <ul style={styles.list}>
              <li>Any lost profits, revenues, or digital assets</li>
              <li>Losses from staking, trading, or telecom interruptions</li>
              <li>Third-party carrier disputes or roaming restrictions</li>
              <li>Regulatory enforcement, compliance delays, or user error</li>
            </ul>
            <p>Total cumulative liability is limited to the amount paid by you in the preceding 3 months.</p>
          </section>

          <section>
            <h2>14. INDEMNIFICATION</h2>
            <p>You agree to defend, indemnify, and hold harmless RZTO and its officers, affiliates, and partners from any claim or demand incase which includes but not limited to User breach of these Terms; Use or misuse of the Platform; Violation of laws or telecom rules in your region; Disputes involving digital wallets or third-party services.</p>
          </section>

          <section>
            <h2>15. EXPORT & SANCTIONS COMPLIANCE</h2>
            <p>You may not use, export, or re-export any services, eSIM, tokens, or software in violation of:</p>
            <ul style={styles.list}>
              <li>SVG laws</li>
              <li>U.S. or international sanctions and embargoes</li>
              <li>Anti-boycott or export compliance laws</li>
            </ul>
            <p>RZTO reserves the right to suspend access from jurisdictions flagged for sanctions or high-risk regulatory concerns.</p>
          </section>

          <section>
            <h2>16. TERMINATION</h2>
            <p>We may terminate your access to the Platform or deactivate your eSIM at any time for:</p>
            <ul style={styles.list}>
              <li>Fraud</li>
              <li>Gaming the reward system</li>
              <li>Breach of terms</li>
              <li>Carrier blacklisting or legal violations</li>
            </ul>
          </section>

          <section>
            <h2>17. ARBITRATION AND DISPUTE RESOLUTION</h2>
            <p>Any dispute shall be resolved via confidential binding arbitration under the Eastern Caribbean Supreme Court Commercial Division, seated in Kingstown, SVG. You waive rights to jury trials or class actions. Claims related to intellectual property or injunctive relief may still be brought in court.</p>
          </section>

          <section>
            <h2>18. MODIFICATIONS</h2>
            <p>We may revise these Terms at any time. We will notify you via email, website alert, or update announcement. Continued use signifies acceptance.</p>
          </section>

          <section>
            <h2>19. CONTACT</h2>
            <p>For support or legal inquiries, contact:</p>
            <p>Email: info@rzto.io</p>
          </section>
        </div>
      </Layout>
    </>
  );
};

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    lineHeight: '1.6',
    padding: '20px',
    color: '#333',
    margin: '30px auto',
    maxWidth: '70%',
    width: '100%',
    boxSizing: 'border-box',
    textAlign: 'justify', // justifies paragraph text
  },
  effectiveDate: {
    fontWeight: 'bold',
    marginBottom: '20px',
    textAlign: 'center', // center the effective date text
  },
  list: {
    listStyleType: 'disc',
    paddingLeft: '20px',
    margin: '10px 0',
    color: '#000',
    fontSize: '14px',
  },
  orderedList: {
    margin: '10px 0',
    paddingLeft: '20px',
    listStyleType: 'decimal',
  }
};


export default Terms;